import {TipoPrescricaoEnum} from '../service-proxies/service-proxies'
export class TipoPrescricaoValues{
    public static Cid = TipoPrescricaoEnum._0
    public static ProcedimentoTuss = TipoPrescricaoEnum._1
    public static ProcedimentoSigtap = TipoPrescricaoEnum._2
    public static MedicamentoTiss = TipoPrescricaoEnum._3
    public static MedicamentoSigtap = TipoPrescricaoEnum._4
}